import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import CustomModal from "../../../../../app/common-components/CustomModal.jsx";
import CompleteTableData from "../../../../../app/common-components/Table/CompleteTableData.jsx";
import CommonBtn from "../../../../../app/common-components/ui-components/Button/Index.jsx";

import { get } from "lodash";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../../app/common-components/ButtonComponent.jsx";
import DetailTable from "../../../../../app/common-components/DetailTable/Index.jsx";
import Spinners from "../../../../../app/common-components/Spinner.jsx";
import { convertEpochToDate, useCommonAlert } from "../../../../../app/utilities/helpers.js";
import { formatDays, sortStringNumber } from "./Constants.js";
import { dataImportDelete } from "./DataImportSlice.js";
import "./style.scss";
import { getSortingValues } from "../../../../../app/Constants.js";



const DataImportTable = (props) => {
    const dispatch = useDispatch();
    const { userName, userRole } = useSelector(
        (state) => state.common.loggedUser
    );
    const {
        listTableDIData,
        listTableDataDICount,
        tableDILoading,
        tableCountDILoading,
        saveDILoader,
        deleteDILoader,
    } = useSelector((state) => state.DataImportConfig);
    const handlePageLimitChange = (limit) => {
        props.handlePageLimitChange(limit);
    };

    const handleSearch = (value) => {
        props.handleSearch(value);
    };

    const handlePageChange = (No) => {
        props.handlePageChange(No);
    };
    const handleOnSorting = (column, headerSortingState) => {
        const { sortingField, isDataSorted } = getSortingValues(
            columns,
            column,
            headerSortingState
        );
        props?.handleOnSorting &&
            props?.handleOnSorting(sortingField, isDataSorted);
    };
    const [state, setState] = useState({
        modalOpen: false,
        modalOpenInfo: false,
        detailData: "",
    });
    const { callCommonAlert, hideCommonAlert } = useCommonAlert();

    const callAlert = (type, msg) => {
        callCommonAlert(type, msg);
        hideCommonAlert();
    };

    const modalBody = () => (
        <>
            <h4 className="delete-h"> Delete Data Import Configuration</h4>
            {deleteDILoader ? <Spinners /> : (<div>
                <p>
                    Are you sure you would like to delete the Data Import Configuration?
                </p>
                <div className="btnswrap btn-dlt">
                    <ButtonComponent
                        text="Cancel"
                        data-testid="cancelBtn"
                        className={"cancelBtnStyle btn btn-primary"}
                        onClick={handleClose}
                    />
                    <ButtonComponent
                        text="Delete"
                        data-testid="deleteBtn"
                        className={"btnStyle btn btn-primary"}
                        onClick={() => handleDelete(state.handleDelete)}
                    />
                </div>
            </div>)}
        </>
    );
    const modalBodyInfo = () => {
        const data = state.detailData.original;
        const detailsTableData = [
            { header: 'Configured By', values: data?.createdBy ? data.createdBy : "-" },
            { header: 'Configured On', values: data?.createdDate ? convertEpochToDate(data.createdDate) : "-" },
            ...(data?.moduleName === "Architecture Compliance"
                ? [
                    {
                        header: 'Groups',
                        values: Array.isArray(data?.groupName) && data.groupName.length > 0
                            ? data.groupName.join(", ")
                            : "-"
                    },
                    {
                        header: 'Services',
                        values: Array.isArray(data?.serviceName) && data.serviceName.length > 0
                            ? data.serviceName.join(", ")
                            : "-"
                    }
                ]
                : []
            ),
            { header: 'Updated By', values: data?.updatedBy ? data?.updatedBy : "-" },
            { header: 'Updated On', values: data?.updatedDate ? convertEpochToDate(data.updatedDate) : "-" }
        ];
        return (
            <>
                <h4 className="schedule-tool">{data?.moduleName} : {data?.tool}</h4>

                <div>
                    <DetailTable data={detailsTableData} />
                </div>
            </>
        );
    };
    const handleCloseInfo = () => {
        setState({
            ...state,
            modalOpenInfo: false,
        });
    };
    const handleDelete = (row) => {
        const id = row;
        dispatch(dataImportDelete({ id, userName })).then((data) => {
            if (data.payload.statusCodeValue == 200) {
                callAlert("success", data.payload.body);
                setState((state) => ({
                    ...state,
                    addBodyOpen: false,
                }));
            } else if (data.payload.statusCodeValue == 400) {
                callAlert("error", data.payload.body);
            } else {
                callAlert("error", "Something went wrong please try again.");
            }
        });
        handleClose();
    };
    const handleClose = () => {
        setState({
            ...state,
            modalOpen: false,
        });
        hideCommonAlert();
    };
    const columns = [
        {
            Header: "Sl. No.",
            accessor: "no",
            thClassName: "detailsCursorTooltip",
            Cell: ({ value, row }) => {
                const data = row.original;
                let serialNumber;
                if (pageNo > 0) {
                    let idx = row.index + 1;
                    serialNumber = pageNo * pageLimit + idx;
                } else {
                    serialNumber = row.index + 1;
                }
                return (
                    <div className={`text-center`}>
                        <div style={{ paddingRight: "18px" }}>{serialNumber}</div>
                    </div>
                );
            },
        },
        {
            Header: "Module",
            accessor: "moduleName",
        },
        {
            Header: "Tool",
            accessor: "tool",
        },
        {
            Header: "Import Frequency",
            accessor: "importFrequency",
        },
        {
            Header: "Import On",
            accessor: "importOn",
            Cell: ({ row }) => {
                if (row.original.importFrequency == "Weekly") {
                    return (
                        <>
                            {formatDays(row.original.importOn)}
                        </>
                    );
                } else if (row.original.importFrequency == "Monthly") {
                    return (
                        <>
                            {sortStringNumber(row.original.importOn)}
                        </>
                    );
                } else {
                    return (
                        <>
                            {row.original.importOn}
                        </>
                    );
                }
            }
        },
        {
            Header: "Import At",
            accessor: "time",
            Cell: ({ value }) => {
                if (!value) {
                    return <td className="text-start">-</td>;
                }
                const [hours, minutes] = value.split(":");
                const hour = parseInt(hours, 10);
                const period = hour >= 12 ? "PM" : "AM";
                const normalHour = hour > 12 ? hour - 12 : hour;
                return (
                    <td className="text-start">{`${normalHour}:${minutes} ${period}`}</td>
                );
            },
        },
        {
            Header: "Last Imported On",
            accessor: "lastTriggeredDateStr",
            Cell: ({ value }) => {
                return (
                    <td className={`text-start`}>
                        {value ? value : "-"}
                    </td>
                );
            },
        },
        // {
        //     Header: "Configured By",
        //     accessor: "createdBy",
        //     Cell: ({ value }) => {
        //         return (
        //             <>
        //                 {value? value : '-' }
        //             </>
        //         );
        //     },
        // },
        // {
        //     Header: "Configured On",
        //     accessor: "createdDate",
        //     Cell: ({ value }) => {
        //         return (
        //             <td className={`text-start`}>
        //                 {value ? convertEpochToDate(value) : "-"}
        //             </td>
        //         );
        //     },
        // },
        {
            Header: "Status",
            thClassName: "detailsCursorTooltip",
            accessor: "status",
            className: "text-center",
            Cell: ({ row }) => {
                return (
                    <label className="toggle-control">
                        <input
                            type="checkbox"
                            className="switchInput"
                            id={row.original.id}
                            checked={row.original.status ? true : false}
                            onChange={(e) => {
                                props.changeStatus(row.original, e.target.checked);
                            }}
                        />
                        <span className="control" data-testid="toggleControl"></span>
                    </label>
                );
            },
        },
        {
            Header: "Details",
            className: "text-center noSort",
            disableSortBy: true,
            thClassName: "templateCursor",
            // isTooltip: "Additional info about the planned action for addressing the vulnerability",
            Cell: ({ row }) => (
                <td
                    className="text-center"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <button
                        onClick={() =>
                            handleShowInfo(row)
                        }
                        // variant="light"
                        className="modelButton p-0"
                        data-testid="infoButton"
                    >
                        <FaInfoCircle
                            className="faInfoCircleStyle"
                            size={15}
                            data-bs-toggle="tooltip"
                            data-bs-placement="left"
                        />
                    </button>
                </td>
            ),
        },
        {
            Header: "Action",
            accessor: "action",
            thClassName: "text-center",
            tdClassName: "text-center",
            disableSortBy: true,
            Cell: ({ row }) => (
                <div className="d-flex justify-content-center  fs-5 ">
                    <div className="px-2">
                        <FiEdit
                            title="Edit"
                            className="iconStyleActions"
                            data-testid="editIcon"
                            onClick={() => {
                                props.getbyId(row?.original);
                            }}
                        />
                    </div>
                    <div className="px-2">
                        <FiTrash2
                            title="Delete"
                            className="iconStyleActions"
                            data-testid="deleteIcon"
                            onClick={() => {
                                setState((state) => ({
                                    ...state,
                                    modalOpen: true,
                                    handleDelete: row.original.id,
                                }));

                            }}
                        />
                    </div>
                </div>
            ),
        },
    ];
    const BtnData = [
        {
            text: "Add",
            btnComponent: (
                <>
                    <CommonBtn
                        name="Add"
                        id="whitelistAdd"
                        clickFunc={() => props.handleAdd(0)}
                        btnStyle="icon-btn"
                        className="btnspace"
                    // icon={<FaPlus className="mx-1" />}
                    // disabled={!userAccess}
                    />
                </>
            ),
        },
    ];
    const handleShowInfo = (row) => {
        setState({
            ...state,
            modalOpenInfo: true,
            detailData: row,
        });
    };

    const pageLimit = get(props, "data.dataImportPageLimit", 10);
    const pageNo = get(props, "data.dataImportPageNo", 0);
    const searchData = get(props, "data.dataImportPageSearch", "");
    const calculatedPageCount = listTableDIData?.totalCount
        ? Math.ceil(listTableDIData?.totalCount / pageLimit)
        : 0;
    const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
    return (
        <>
            {/* {tableDILoading || tableCountDILoading || saveDILoader || deleteDILoader?(
                <Spinners/>
            ):( */}
            <CompleteTableData
                isLoading={tableDILoading}
                columns={columns}
                data={listTableDIData?.data || []}
                listCount={listTableDIData?.totalCount}
                pageLimit={pageLimit}
                curentPageNumber={pageNo}
                totalPageCount={finalPageCount}
                btnData={BtnData}
                searchKey={searchData}
                onPageLimitChange={handlePageLimitChange}
                onSearch={handleSearch}
                onPageNoChange={handlePageChange}
                headerSortingState={props.headerSortingState}
                onSorting={handleOnSorting}
                moveSearchToEnd={true}
                tableHeaderStyle="headerTable"
            />
            {/* )} */}
            <CustomModal
                modalOpen={state.modalOpen}
                modalBody={modalBody}
                modalTitle={"Delete Configuration"}
                closeBtn={false}
                closeBtnFuc={handleClose}
            />
            <CustomModal
                modalOpen={state.modalOpenInfo}
                modalBody={modalBodyInfo}
                modalHide={handleCloseInfo}
                closeBtn={true}
                closeBtnFuc={handleCloseInfo}
            />
        </>
    );
};

export default DataImportTable;